import Config from "../Config";
import { authHeaderLicman } from "../helpers/requestHelpers";

const config = new Config();

/**
 * Starts instance provisioning via the fgfunctions admin-panel endpoint.
 *
 * @param {Object} payload - Admin form fields
 * @param {string} payload.email - Required customer email
 * @param {string} [payload.companyName] - Optional company name
 * @param {string} [payload.firstName] - Optional first name
 * @param {string} [payload.lastName] - Optional last name
 * @param {string} [payload.phoneNumber] - Optional phone number
 * @returns {Function} Redux thunk resolving to the API JSON body
 */
export function provisionInstanceFromAdminPanel(payload) {
    return async function () {
        const requestOptions = {
            method: "POST",
            headers: { ...authHeaderLicman(), "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        };

        const response = await fetch(
            config.apiUrl + `/${config.licmanModule}/provisionInstanceFromAdminPanel`,
            requestOptions
        );

        let body = null;
        try {
            body = await response.json();
        } catch {
            body = null;
        }

        if (!response.ok) {
            const message =
                (body && (body.error || body.errorMessage || body.details)) ||
                `Request failed with status ${response.status}`;
            const error = new Error(typeof message === "string" ? message : JSON.stringify(message));
            error.status = response.status;
            error.body = body;
            throw error;
        }

        return body;
    };
}
